import React from 'react';
import { Payment } from '../../types/Payment';
import '../../css/modal.css';

interface PaymentHistoryModalProps {
  isOpen: boolean;
  onClose: () => void;
  payments: Payment[];
  total: number;
}

const PaymentHistoryModal: React.FC<PaymentHistoryModalProps> = ({ isOpen, onClose, payments, total }) => {
  if (!isOpen) return null;

  const paid = payments.reduce((sum, p) => sum + (parseFloat(String(p.amount)) || 0), 0);
  const balance = total - paid;

  return (
    <div className="modal-backdrop">
      <div className="modal">
        <h3>Payment History</h3>
        <p><strong>Total:</strong> ₹{total.toLocaleString('en-IN')}</p>
        <p><strong>Paid:</strong> ₹{paid.toLocaleString('en-IN')}</p>
        <p><strong>Balance:</strong> ₹{balance.toLocaleString('en-IN')}</p>

        <table className="payment-table">
          <thead>
            <tr>
              <th>Date</th>
              <th>Amount</th>
              <th>Method</th>
              <th>Status</th>
            </tr>
          </thead>
          <tbody>
            {payments.map(p => (
              <tr key={p.id}>
                <td>{new Date(p.created_at).toLocaleDateString()}</td>
                <td>₹{p.amount.toLocaleString('en-IN')}</td>
                <td>{p.method}</td>
                <td>{p.status}</td>
              </tr>
            ))}
          </tbody>
        </table>

        <button className="close-btn" onClick={onClose}>×</button>
      </div>
    </div>
  );
};

export default PaymentHistoryModal;
